import { type ReactNode } from 'react';

const BTN =
  'inline-flex h-8 w-8 items-center justify-center rounded-md text-text-secondary transition-colors hover:bg-white/[0.04] hover:text-text-primary data-[active=true]:bg-white/[0.06] data-[active=true]:text-brand-red';

type Props = {
  active: boolean;
  onClick: () => void;
  title: string;
  children: ReactNode;
};

export function ToolButton({
  active,
  onClick,
  title,
  children,
}: Props): ReactNode {
  return (
    <button
      type="button"
      data-active={active}
      onClick={onClick}
      className={BTN}
      title={title}
    >
      {children}
    </button>
  );
}
